<template>
  <span class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium leading-5"
    :class="{
      ' bg-green-100 text-green-800': isEnabled,
      'bg-red-100 text-red-800': isDisabled,
      'bg-yellow-100 text-yellow-800': isExpiring,
      'bg-red-100 text-red-800': isExpired,
    }"
  >
    {{ status | name }}
  </span>
</template>

<script>
import GiftCardStatus from "@/data/giftCardStatuses.js";

export default {
  name: "GiftCardStatus",
  filters: {
    name: GiftCardStatus.getName
  },
  props: {
    status: {
      type: String,
      required: true
    }
  },
  computed: {
    isEnabled() {
      return this.status === GiftCardStatus.Enabled;
    },
    isDisabled() {
      return this.status === GiftCardStatus.Disabled;
    },
    isExpiring() {
      return this.status === GiftCardStatus.Expiring;
    },
    isExpired() {
      return this.status === GiftCardStatus.Expired;
    },
  },
};
</script>
